export default "__VITE_ASSET__q7jwe2qR__"